import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(null);
  const [productOpen, setProductOpen] = useState(false);

  return (
    <header className="bg-white shadow-md py-4 px-6 fixed top-0 left-0 w-full z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between relative">
        <Link to="/" className="text-2xl font-bold text-blue-700">JDWinTech</Link>

        {/* ✅ 데스크탑 메뉴 */}
        <nav className="space-x-16 hidden md:flex absolute left-1/2 transform -translate-x-1/2">
          {/* ✅ 회사소개 드롭다운 */}
          <div
            className="relative"
            onMouseEnter={() => setMenuOpen('company')}
            onMouseLeave={(e) => {
              const related = e.relatedTarget;
              if (!e.currentTarget.contains(related)) {
                setMenuOpen(false);
              }
            }}
          >
            <button className="text-gray-800 font-semibold hover:text-blue-600">제이디윈테크</button>
            <div
              className={`absolute top-full left-0 mt-0 w-48 bg-white rounded-md shadow-lg z-50 transition-opacity duration-200 ${
                menuOpen === 'company' ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'
              }`}
            >
              <ul className="py-2 text-sm text-gray-700">
                <li><Link to="/company" className="block px-4 py-2 hover:bg-gray-100">회사소개</Link></li>
                <li><Link to="/history" className="block px-4 py-2 hover:bg-gray-100">회사연혁</Link></li>
                <li><Link to="/certifications" className="block px-4 py-2 hover:bg-gray-100">특허/인증/수상</Link></li>
              </ul>
            </div>
          </div>

          {/* ✅ 제품소개 드롭다운 */}
          <div
            className="relative"
            onMouseEnter={() => setProductOpen(true)}
            onMouseLeave={(e) => {
              const related = e.relatedTarget;
              if (!e.currentTarget.contains(related)) {
                setProductOpen(false);
              }
            }}
          >
            <button className="text-gray-800 font-semibold hover:text-blue-600">제품소개</button>
            <div
              className={`absolute top-full left-0 mt-0 w-48 bg-white rounded-md shadow-lg z-50 transition-opacity duration-200 ${
                productOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'
              }`}
            >
              <ul className="py-2 text-sm text-gray-700">
                <li><Link to="/products/smoke" className="block px-4 py-2 hover:bg-gray-100">배연창</Link></li>
                <li><Link to="/products/vent" className="block px-4 py-2 hover:bg-gray-100">환기창</Link></li>
                <li><Link to="/products/closer" className="block px-4 py-2 hover:bg-gray-100">창문형 자동폐쇄장치</Link></li>
              </ul>
            </div>
          </div>

          <Link to="/performance" className="text-gray-800 font-semibold hover:text-blue-600">실적이력</Link>

          {/* ✅ 고객지원 드롭다운 */}
          <div
            className="relative"
            onMouseEnter={() => setMenuOpen('support')}
            onMouseLeave={(e) => {
              const related = e.relatedTarget;
              if (!e.currentTarget.contains(related)) {
                setMenuOpen(null);
              }
            }}
          >
            <button className="text-gray-800 font-semibold hover:text-blue-600">고객지원</button>
            <div
              className={`absolute top-full left-0 mt-0 w-48 bg-white rounded-md shadow-lg z-50 transition-opacity duration-200 ${
                menuOpen === 'support' ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'
              }`}
            >
              <ul className="py-2 text-sm text-gray-700">
                <li><Link to="/notice" className="block px-4 py-2 hover:bg-gray-100">공지사항</Link></li>
                <li><Link to="/qna" className="block px-4 py-2 hover:bg-gray-100">Q&A</Link></li>
                <li><Link to="/downloads" className="block px-4 py-2 hover:bg-gray-100">자료실</Link></li>
              </ul>
            </div>
          </div>
        </nav>

        {/* ✅ 모바일 메뉴 토글 */}
        <button className="md:hidden text-gray-800" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* ✅ 모바일 메뉴 */}
      {mobileOpen && (
        <div className="md:hidden bg-white shadow-md px-6 py-4 space-y-4">
          <div className="border-b pb-2">
            <p className="text-gray-800 font-semibold">제이디윈테크</p>
            <ul className="pl-4 text-sm text-gray-700 space-y-2 mt-1">
              <li><Link to="/company" onClick={() => setMobileOpen(false)}>회사소개</Link></li>
              <li><Link to="/history" onClick={() => setMobileOpen(false)}>회사연혁</Link></li>
              <li><Link to="/certifications" onClick={() => setMobileOpen(false)}>특허/인증/수상</Link></li>
            </ul>
          </div>

          <div className="border-b pb-2">
            <p className="text-gray-800 font-semibold">제품소개</p>
            <ul className="pl-4 text-sm text-gray-700 space-y-1 mt-1">
              <li><Link to="/products/smoke" onClick={() => setMobileOpen(false)}>배연창</Link></li>
              <li><Link to="/products/vent" onClick={() => setMobileOpen(false)}>환기창</Link></li>
              <li><Link to="/products/closer" onClick={() => setMobileOpen(false)}>창문형 자동폐쇄장치</Link></li>
            </ul>
          </div>

          <div className="border-b pb-2">
            <p className="text-gray-800 font-semibold">고객지원</p>
            <ul className="pl-4 text-sm text-gray-700 space-y-1 mt-1">
              <li><Link to="/notice" onClick={() => setMobileOpen(false)}>공지사항</Link></li>
              <li><Link to="/qna" onClick={() => setMobileOpen(false)}>Q&A</Link></li>
              <li><Link to="/downloads" onClick={() => setMobileOpen(false)}>자료실</Link></li>
            </ul>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
